// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form":"form___VsDgT","row":"row___i88c7","full":"full___oUl2A","half":"half___zN8JQ"};